var SocialPopularSearches = {
  init: function() {
    this.setVariables();
    this.retrieveSearches();
  },
  setVariables: function() {
    this.$searchList = $("#socialPopularSearches");
    this.$noContent = $("#noSocialPopularSearches");
  },
  retrieveSearches: function() {
    var _self = this;

    var url = Config.contextPath + "/app/portlets/popularitems/worker.jsp";
    var data = {
      SToken: Config.csrf.value,
      items: "companySearches",
      timerange: "lastweek"
    };

    $.post(url, data)
      .done(function(r) {
        var hasItems = r !== undefined && r.companySearches !== undefined && r.companySearches.length > 0;

        if (hasItems) {
          var items = r.companySearches;

          for (var i = 0; i < items.length; i++) {
            var $link = $("<a>");
            var $li = $("<li></li>");
            var url = RA.buildSearchUrl(items[i]);

            $link.attr("href", url);
            $link.text(items[i]);
            $li.append($link);

            _self.$searchList.append($li);
          }
        } else {
          _self.$searchList.addClass("hide");
          _self.$noContent.removeClass("hide");
        }
      });
  }
};